import { Box, Typography, TypographyProps } from "@mui/material";
import React from "react";

export const Subtitle1Text: React.FC<
  TypographyProps<React.ElementType, { component?: React.ElementType }>
> = (props) => (
  <Typography component="div">
    <Box
      fontSize={18}
      lineHeight={"26.24px"}
      fontWeight={400}
      letterSpacing={0.5}
    >
      <Typography variant="inherit" component="p" {...props} />
    </Box>
  </Typography>
);
